import ADB from "../../../../libs/MediaSDK";
import { akamai } from "../../../globals";
import { debug } from "@medscape/streaming-video-player/src/js/utils/debug-log";
const { Event: ADB_MEDIA_EVENTS } = ADB.Media;
const { MUTE_CHANGE, DESTROY } = akamai.amp.Events;

class Mute {
  constructor(amp, tracker, stateObjects) {
    this.amp = amp;
    this.tracker = tracker;
    this.stateObjects = stateObjects;
    this.subscriptions = [];
    //debug.log("[MediaAnalyticsTracking][Mute][constructor]:", this);
  }

  destroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }
  end() {
    this.destroy();
  }
  start() {
    this.destroy();
    const { amp } = this;

    const mute$ = amp.AmpEventsSources[MUTE_CHANGE].subscribe((data) => {
      this.onMuteChange(data);
    });

    const destroy$ = amp.AmpEventsSources[DESTROY].subscribe((data) => {
      this.destroy();
    });
    this.subscriptions = [destroy$, mute$];
    if(amp.getMuted() === true) {
        this.onMuteChange();
    }
  }

  onMuteChange() {
    const { amp, tracker } = this;
    const { Mute: stateObject } = this.stateObjects;
    const stateName = amp.getMuted()
      ? ADB_MEDIA_EVENTS.StateStart
      : ADB_MEDIA_EVENTS.StateEnd;
    debug.log(
      "[MediaAnalyticsTracking][Mute][onMutechange] tracker.trackEvent \n\tstateName:",
      stateName,
      "\n\tstateObject:",
      stateObject
    );
    tracker.trackEvent(stateName, stateObject);
  }
}

export default Mute;
